import { connect } from 'react-redux'
import { State } from 'interfaces/state'
import DebtsPage from 'components/features/pfm/DebtsPage/DebtsPage'
import { InternalPageProps } from 'interfaces/pages'
import internal from 'components/utils/Internal'

const mapStateToProps = (state: State): InternalPageProps => ({
  timeframe: state.app.debts.timeframe,
  categoryId: state.app.debts.categories.selectedId,
})

const DebtsContainer = internal(connect<InternalPageProps>(mapStateToProps)(DebtsPage))
export default DebtsContainer
